const formatPriceMixin = {
  methods: {
    formatPrice(value, dig = 2) {
      const val = (value/1).toFixed(dig ).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
}

export default formatPriceMixin



// WEBPACK FOOTER //
// ./src/mixins/formatPriceMixin.js